//#region IMPORT
import React from 'react';
/** Services Import */
import IndexedDb from '../../Services/IndexedDb/IndexedDb';
import {
  Stack as MuiStack,
  Card as MuiCard,
  Button as MuiButton,
  Box as MuiBox,
  Slide,
  Typography,
  Popper,
  Grow,
  Paper,
  MenuItem,
  MenuList,
  ClickAwayListener,
  Divider,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Button,
  Checkbox,
  Combo,
  DatePicker,
  Radio,
  Dialog,
} from '../../Components/MUIs';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  DriveFolderUpload as FileUploadIcon,
  Refresh as RefreshIcon,
  Copyright as CopyrightIcon,
  Article as ArticleIcon,
  HelpOutline as HelpOutlineIcon,
} from '@mui/icons-material';
import FileModalCommonF from '../FileModalCommon/FileModalCommonF';
import useResponsiveValue from '../../hooks/useResponsiveValue';
import { useSelector } from 'react-redux';
//#endregion

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function ButtonAuth({
  /** Stack Props */
  menuId, // string
  searchBox = 'Y',
  searchYn = 'N', // string
  fileYn = 'N', // string
  addYn = 'Y', // string
  saveYn = 'Y', // string
  deleteYn = 'Y', // string
  printYn = 'Y', // string
  multiPrintYn = 'N', // string
  printItem = [],
  fileUploadYn = 'N', // string
  refreshYn = 'N', // string
  applyYn = 'N', // string
  applyCancleYn = 'Y',
  applyName = '', //string
  applyCancleName = '', //string
  applyExtra,
  imageButtonYn = 'N', // string
  imageButtonUrl = '', // string
  imageButtonSrc = '', // string (이미지 경로)
  imageButtonAlt = '', // string
  imageButtonSx = {}, // object
  imageButtonTooltip = '', // string (툴팁 텍스트)
  other1,
  direction = 'column', // 'column-reverse' | 'column' | 'row-reverse' | 'row'
  justifyContent, // 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly'
  alignItems, // 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  divider, // node
  spacing = 1, // number
  sx, // object
  useFlexGap, // bool

  /** Condition Props */
  conditions = [], // object array
  placeholder = '검색', // string

  /** Button Props */
  buttonsSx, // object
  currentLocale = 'en', // string
  searchClick = () => {},
  addClick = () => {},
  saveClick = () => {},
  deleteClick = () => {},
  printClick = () => {},
  fileUploadClick = () => {},
  refreshClick = () => {},
  applyClick = () => {},
  applyCancleClick = () => {},
  fileSaveClick = () => {},

  /** Grid Props */
  grids, // node
  gridStyle, // object

  /** Mobile List */
  lists,

  /** Change Props */
  setChangedRowData,

  /** File Props */
  modalTitle,
  gridTitle,
  extension,
  deletePayload1,
  deleteUrl,
  searchPayload1,
  searchUrl,
  savePayload1,
  saveFilePath1,
  saveUrl,
  custCd,
  fileValidFc,
}) {
  const { companyInfo, userInfo, custInfo, lanInfo, menuInfo } = useSelector(
    (state) => state.BaseInfo
  );

  const [authData, setAuthData] = React.useState([]);
  const [dialogToggle1, setDialogToggle1] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });
  const [dialogToggle2, setDialogToggle2] = React.useState({
    open: false,
    title: '',
    content: <></>,
    contentText: '',
    actions: <></>,
  });

  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [searchText, setSearchText] = React.useState('');
  const anchorRef = React.useRef(null);
  const cardWidth = useResponsiveValue([
    { min: 2560, value: '2432px' },
    { min: 2400, max: 2560, value: '2272px' },
    { min: 2300, max: 2400, value: '2180px' },
    { min: 2200, max: 2300, value: '2070px' },
    { min: 2133, max: 2200, value: '2005px' },
    { min: 2050, max: 2133, value: '1930px' },
    { min: 2000, max: 2050, value: '1890px' },
    { min: 1950, max: 2000, value: '1840px' },
    { min: 1900, max: 1950, value: '1800px' },
    { min: 1850, max: 1900, value: '1750px' },
    { min: 1800, max: 1850, value: '1700px' },
    { min: 1745, max: 1800, value: '1670px' },
    { min: 1670, max: 1745, value: '1630px' },
    { min: 1600, max: 1670, value: '1550px' },
    { min: 1500, max: 1600, value: '1480px' },
    { min: 1400, max: 1500, value: '1400px' },
    { min: 1300, max: 1400, value: '1280px' },
    { min: 0, max: 1300, value: '1200px' },
  ]); // 조회조건영역, 데이터영역 카드 넓이
  const searchHeight = useResponsiveValue([
    { min: 2560, value: '73px' },
    { min: 0, max: 2560, value: '73px' },
  ]); // 조회조건영역 카드 높이
  const dataHeight = useResponsiveValue([
    { min: 2560, value: '1051px' },
    { min: 2400, max: 2560, value: '972px' },
    { min: 2133, max: 2400, value: '841px' },
    { min: 1920, max: 2133, value: '736px' },
    { min: 1745, max: 1920, value: '650px' },
    { min: 1536, max: 1745, value: '547px' },
    { min: 0, max: 1536, value: '421px' },
  ]); // 데이터영역 카드 높이

  const HandleToggle1 = () => {
    if (fileValidFc) {
      const isValid = fileValidFc(); // true/false 받아옴
      if (!isValid) {
        setOpen(false); // 실패일 때만 닫기
        return;
      }
    }
    setOpen((prevOpen) => !prevOpen); // 성공 시 정상 토글
  };
  const HandleToggle2 = () => {
    if (fileValidFc) {
      const isValid = fileValidFc(); // true/false 받아옴
      if (!isValid) {
        setOpen2(false); // 실패일 때만 닫기
        return;
      }
    }
    setOpen2((prevOpen) => !prevOpen); // 성공 시 정상 토글
  };
  const HandleClose1 = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  function HandleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }
  React.useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    try {
      setAuthData(
        menuInfo.filter(
          (f) => f.menuId === menuId && f.authCd === userInfo.authCd
        )[0]
      );
    } catch (e) {
      console.log(e);
    }
  };

  const WebConditions = () => {
    if (conditions.length === 0) {
      return <div></div>;
    } else {
      return conditions.map((item, index) => {
        switch (item.type) {
          case 'button':
            return (
              <Button
                key={index}
                name={item.name}
                children={item.children}
                classes={item.classes}
                color={item.color}
                component={item.component}
                disabled={item.disabled}
                disableElevation={item.disableElevation}
                disableFocusRipple={item.disableFocusRipple}
                disableRipple={item.disableRipple}
                endIcon={item.endIcon}
                fullWidth={item.fullWidth}
                href={item.href}
                size={item.size}
                startIcon={item.startIcon}
                sx={{ mx: 1, ...item.sx }}
                variant={item.variant}
                onClick={item.onClick}
                onKeyUp={item.onKeyUp}
                onKeyDown={item.onKeyDown}
                onMouseUp={item.onMouseUp}
                onMouseOver={item.onMouseOver}
                onMouseDown={item.onMouseDown}
                onMouseOut={item.onMouseOut}
              />
            );
          case 'checkbox':
            return (
              <Checkbox
                key={index}
                nameSx={item.nameSx}
                name={item.name}
                disabled={item.disabled}
                labelPlacement={item.labelPlacement}
                checked={item.checked}
                checkedIcon={item.checkedIcon}
                classes={item.classes}
                color={item.color}
                defaultChecked={item.defaultChecked}
                disableRipple={item.disableRipple}
                icon={item.icon}
                id={item.id}
                indeterminate={item.indeterminate}
                indeterminateIcon={item.indeterminateIcon}
                inputProps={item.inputProps}
                inputRef={item.inputRef}
                required={item.required}
                size={!item.size ? 'small' : item.size}
                sx={{ mx: 1, ...item.sx }}
                value={item.value}
                onChange={item.onChange}
              />
            );
          case 'combo':
            return (
              <Combo
                key={index}
                items={item.items}
                wrapSx={{
                  mx: 1,
                  width: '200px',
                  ...item.wrapSx,
                }}
                color={item.color}
                size={!item.size ? 'small' : item.size}
                fullWidth={item.fullWidth}
                required={item.required}
                disabled={item.disabled}
                autoWidth={item.autoWidth}
                classes={item.classes}
                defaultOpen={item.defaultOpen}
                displayEmpty={item.displayEmpty}
                IconComponent={item.IconComponent}
                id={item.id}
                input={item.input}
                inputProps={item.inputProps}
                name={item.name}
                nameId={item.nameId}
                MenuProps={item.MenuProps}
                multiple={item.multiple}
                native={item.native}
                open={item.open}
                SelectDisplayProps={item.SelectDisplayProps}
                sx={item.sx}
                value={item.value}
                variant={item.variant}
                onOpen={item.onOpen}
                onClose={item.onClose}
                onChange={item.onChange}
              />
            );
          case 'datePicker':
            return (
              <DatePicker
                key={index}
                autoFocus={item.autoFocus}
                closeOnSelect={item.closeOnSelect}
                defaultValue={item.defaultValue}
                value={item.value}
                desktopModeMediaQuery={item.desktopModeMediaQuery}
                disabled={item.disabled}
                disableFuture={item.disableFuture}
                disableHighlightToday={item.disableHighlightToday}
                disableOpenPicker={item.disableOpenPicker}
                disablePast={item.disablePast}
                displayWeekNumber={item.displayWeekNumber}
                fixedWeekNumber={item.fixedWeekNumber}
                formatDensity={item.formatDensity}
                inputRef={item.inputRef}
                name={item.name}
                loading={item.loading}
                localeText={item.localeText}
                maxDate={item.maxDate}
                minDate={item.minDate}
                monthsPerRow={item.monthsPerRow}
                open={item.open}
                openTo={item.openTo}
                orientation={item.orientation}
                reduceAnimations={item.reduceAnimations}
                referenceDate={item.referenceDate}
                selectedSections={item.selectedSections}
                showDaysOutsideCurrentMonth={item.showDaysOutsideCurrentMonth}
                slotProps={{
                  ...item.slotProps,
                  textField: { size: 'small' },
                }}
                slots={item.slots}
                sx={{
                  width: '200px',
                  mx: 1,
                  ...item.sx,
                }}
                timezone={item.timezone}
                view={item.view}
                views={item.views}
                format={item.format}
                viewRenderers={item.viewRenderers}
                yearsPerRow={item.yearsPerRow}
                dayOfWeekFormatter={item.dayOfWeekFormatter}
                onAccept={item.onAccept}
                onChange={item.onChange}
                onClose={item.onClose}
                onError={item.onError}
                onMonthChange={item.onMonthChange}
                onOpen={item.onOpen}
                onSelectedSectionsChange={item.onSelectedSectionsChange}
                onViewChange={item.onViewChange}
                onYearChange={item.onYearChange}
                renderLoading={item.renderLoading}
                shouldDisableDate={item.shouldDisableDate}
                shouldDisableMonth={item.shouldDisableMonth}
                shouldDisableYear={item.shouldDisableYear}
                currentLocale={item.currentLocale}
              />
            );
          case 'radio':
            return (
              <Radio
                key={index}
                items={item.items}
                value={item.value}
                row={item.row}
                onChange={item.onChange}
              />
            );
          case 'other':
            return <div key={index}>{item.item}</div>;

          case 'custom':
            return (
              <div
                key={item.key || index}
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                {typeof item.render === 'function' ? item.render() : null}
              </div>
            );
        }
      });
    }
  };

  return (
    <MuiStack
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      divider={divider}
      spacing={spacing}
      sx={{
        width: '100%',
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...sx,
      }}
      useFlexGap={useFlexGap}
    >
      <MuiCard
        sx={{
          width: cardWidth,
          height: searchHeight,
          flexShrink: 0, // 공간이 부족해도 이 요소는 유지(영역이 줄어들지 않음)
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderColor: 'divider',
          borderRadius: '10px',
          p: 1,
          px: 2,

          ...buttonsSx,
        }}
      >
        <MuiBox
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {WebConditions()}
          {searchBox === 'Y' && (
            <TextField
              placeholder={placeholder}
              variant="outlined"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  paddingRight: 0,
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ height: '100%' }}>
                    <MuiButton
                      edge="end"
                      size="small"
                      sx={{
                        borderLeft: 1,
                        borderColor: 'divider',
                        color: 'rgba(0, 0, 0, 0.54)', // 기본 색상
                      }}
                      style={{
                        padding: '0px',
                        borderRadius: '0px',
                        borderTopRightRadius: '8px',
                        borderBottomRightRadius: '8px',
                      }}
                      onClick={() => searchClick(searchText)} // ex. searchClick={{(e) => console.log(e)}} 매개변수를 통해 텍스트값 전달
                    >
                      <SearchIcon sx={{ m: 0 }} style={{ margin: '0px' }} />
                    </MuiButton>
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  searchClick(searchText);
                }
              }}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          )}

          {imageButtonYn === 'Y' && imageButtonUrl && (
            <MuiBox sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              <MuiButton
                component="a"
                href={imageButtonUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                sx={{
                  p: 0.5,
                  minWidth: 'auto',
                  height: 'auto',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  backgroundColor: '#fff',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease-in-out',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden',
                  '&:hover': {
                    backgroundColor: '#f5f5f5',
                    borderColor: '#2196F3',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    transform: 'translateY(-1px)',
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                  },
                  ...imageButtonSx,
                }}
              >
                {imageButtonSrc ? (
                  <MuiBox
                    component="img"
                    src={imageButtonSrc}
                    alt={imageButtonAlt || 'Button Image'}
                    sx={{
                      height: 'auto',
                      maxHeight: '30px',
                      width: 'auto',
                      maxWidth: '180px',
                      objectFit: 'contain',
                      display: 'block',
                      m: 0,
                      p: 0,
                    }}
                  />
                ) : (
                  <Typography variant="body2">이미지 버튼</Typography>
                )}
              </MuiButton>
              {imageButtonTooltip && (
                <Tooltip
                  title={imageButtonTooltip}
                  arrow
                  placement="top"
                  enterDelay={300}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: '0.9rem',
                        padding: '12px 16px',
                        maxWidth: 400,
                        backgroundColor: '#fff',
                        color: '#333',
                        border: '1px solid #ddd',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        whiteSpace: 'pre-wrap',
                      },
                    },
                    arrow: {
                      sx: {
                        color: '#fff',
                        '&::before': {
                          border: '1px solid #ddd',
                        },
                      },
                    },
                  }}
                >
                  <IconButton
                    size="small"
                    sx={{
                      ml: 0.5,
                      p: 0.5,
                      color: '#f44336',
                      '&:hover': {
                        backgroundColor: 'rgba(244, 67, 54, 0.08)',
                      },
                    }}
                  >
                    <HelpOutlineIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </MuiBox>
          )}
        </MuiBox>
        <MuiBox sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {other1 && other1}

          {fileYn === 'Y' && (
            <MuiButton
              sx={{ color: '#2196F3', borderColor: '#2196F3' }}
              size={''}
              variant="outlined"
              onClick={() => HandleToggle2()}
            >
              <ArticleIcon fontSize={'small'} />
              서식
            </MuiButton>
          )}
          {applyYn === 'Y' && (
            <>
              {applyExtra}
              <MuiButton
                sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                size={''}
                variant="outlined"
                onClick={applyClick}
              >
                {applyName}
              </MuiButton>
              {applyCancleYn === 'Y' && (
                <MuiButton
                  sx={{ color: '#2196F3', borderColor: '#2196F3' }}
                  size={''}
                  variant="outlined"
                  onClick={applyCancleClick}
                >
                  {applyCancleName}
                </MuiButton>
              )}
            </>
          )}
          {/* {searchYn === "Y" && (
            <MuiButton
              sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }}
              size={""}
              variant="outlined"
              onClick={searchClick}
            >
              <SearchIcon fontSize={""} />
              검색
            </MuiButton>
          )}

          {authData.SAVE_YN === "Y" && addYn === "Y" && (
            <MuiButton
              sx={{ m: 1, color: "#2CA900", borderColor: "#2CA900" }}
              size={""}
              variant="outlined"
              onClick={addClick}
            >
              <AddIcon fontSize={""} />
              추가
            </MuiButton>
          )} */}
          {authData?.saveYn === 'Y' && saveYn === 'Y' && (
            <MuiButton
              sx={{ color: '#2CA900', borderColor: '#2CA900' }}
              size={''}
              variant="outlined"
              onClick={saveClick}
            >
              <SaveIcon fontSize={'small'} />
              저장
            </MuiButton>
          )}
          {/* {authData.DELETE_YN === "Y" && deleteYn === "Y" && (
            <MuiButton
              sx={{ m: 1, color: "#D32F2F", borderColor: "#D32F2F" }}
              size={""}
              variant="outlined"
              onClick={() => {
                setDialogToggle2({
                  ...dialogToggle2,
                  open: true,
                  title: "삭제",
                  content: [
                    <MuiBox sx={{ height: "100%", width: "400px" }}>
                      <Typography>선택한 항목을 삭제하시겠습니까?</Typography>
                    </MuiBox>,
                  ],
                });
              }}
            >
              <DeleteIcon fontSize={""} />
              삭제
            </MuiButton>
          )} */}

          {authData?.printYn === 'Y' &&
          printYn === 'Y' &&
          multiPrintYn === 'Y' ? (
            <div>
              <MuiButton
                ref={anchorRef}
                id="composition-button"
                aria-controls={open ? 'composition-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                sx={{ color: '#9370DB', borderColor: '#9370DB' }}
                size={''}
                variant="outlined"
                onClick={HandleToggle1}
              >
                <PrintIcon fontSize={'small'} />
                인쇄
              </MuiButton>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
                sx={{ zIndex: 1300 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom-start'
                          ? 'left top'
                          : 'left bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={HandleClose1}>
                        <MenuList
                          autoFocusItem={open}
                          id="composition-menu"
                          aria-labelledby="composition-button"
                          onKeyDown={HandleListKeyDown}
                        >
                          {/* {printItem.map((_item, _index) => {
                            return (
                              <>
                                <MenuItem
                                  key={_index}
                                  onClick={(e) => {
                                    _item.onClick();
                                    HandleClose1(e);
                                  }}
                                  sx={{ fontSize: '14px' }}
                                >
                                  {_item.name}
                                </MenuItem>
                                {_index < printItem.length - 1 && <Divider />}
                              </>
                            );
                          })} */}
                          {printItem.map((_item, _index) => (
                            <React.Fragment key={_item.name || _index}>
                              <MenuItem
                                onClick={(e) => {
                                  _item.onClick();
                                  HandleClose1(e);
                                }}
                                sx={{ fontSize: '14px' }}
                              >
                                {_item.name}
                              </MenuItem>
                              {_index < printItem.length - 1 && <Divider />}
                            </React.Fragment>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
          ) : authData?.printYn === 'Y' && printYn === 'Y' ? (
            <MuiButton
              sx={{ color: '#9370DB', borderColor: '#9370DB' }}
              size={''}
              variant="outlined"
              onClick={printClick}
            >
              <PrintIcon fontSize={'small'} />
              인쇄
            </MuiButton>
          ) : (
            <></>
          )}
          {/* {fileUploadYn === "Y" && (
            <MuiButton
              ref={anchorRef}
              id="composition-button"
              aria-controls={open ? "composition-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }}
              variant="outlined"
              size={""}
              onClick={fileUploadClick}
            >
              <FileUploadIcon fontSize={""} />
              파일업로드
            </MuiButton>
          )}
          {refreshYn === "Y" && (
            <MuiButton
              sx={{ m: 1, color: "#2196F3", borderColor: "#2196F3" }}
              size={""}
              variant="outlined"
              onClick={refreshClick}
            >
              <RefreshIcon fontSize={""} />
              새로고침
            </MuiButton>
          )} */}
        </MuiBox>
      </MuiCard>

      <MuiCard
        sx={{
          width: cardWidth,
          height: '730px',
          borderRadius: '10px',
          bgcolor: '#F2F6F9',
        }}
      >
        <div
          className="ag-theme-alpine"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            ...gridStyle,
          }}
        >
          {grids}
        </div>
      </MuiCard>
      <Dialog
        sx={{ height: '250px' }}
        open={dialogToggle1.open}
        onClose={() => setDialogToggle1(false)}
        fullScreen
        TransitionComponent={Transition}
        title={dialogToggle1.title}
        content={dialogToggle1.content}
        contentText={dialogToggle1.contentText}
        actions={dialogToggle1.actions}
        closeButtonName={'닫기'}
      />
      {fileYn === 'Y' && (
        <FileModalCommonF
          modalTitle={modalTitle}
          gridTitle={gridTitle}
          extension={extension}
          open={open2}
          onClose={HandleToggle2}
          deletePayload1={deletePayload1}
          deleteUrl={deleteUrl}
          searchPayload1={searchPayload1}
          searchUrl={searchUrl}
          saveUrl={saveUrl}
          savePayload1={savePayload1}
          saveFilePath1={saveFilePath1}
          fileValidFc={fileValidFc}
          custCd={custCd ?? null} // ✅ custCd 없으면 null
        />
      )}
    </MuiStack>
  );
}

export default React.memo(ButtonAuth);
